<div class="d-flex flex-row">
  <fa-icon
    wlAutomationId="wl-error-icon"
    class="icon icon--danger align-self-center"
    icon="triangle-exclamation"
  ></fa-icon>
  @if (message) {
    <wl-rich-text-wrapper wlAutomationId="wl-error-message" [field]="message">
      <p class="text-small text-danger text-start fst-italic ms-2 mb-0"></p>
    </wl-rich-text-wrapper>
  }
  @if (messageTranslationKey) {
    <p
      wlAutomationId="wl-error-translated-message"
      class="text-small text-danger text-start fst-italic ms-2 mb-0"
    >
      {{ messageTranslationKey | translate: messageTranslationParams }}
    </p>
  }
</div>
